/**
 *
 *
 *
 *   EDITING THIS FILE REQUIRES EDITS TO EMAIL TEMPLATE PROJECT REPO FILE AS WELL TO KEEP THEM IN SYNC
 *
 *
 *
 *
 */

import {LOCALES} from '@utils/locales/locales';

export const POST_BOOKING_APPROVAL_DENIED_TEMPLATE_DEFAULTS = {
  [LOCALES.EN]: {
    subject: 'Trip Notification - Trip Denied',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Trip Notification - Trip Denied',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hello <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Your trip has been denied.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>You are receiving this notification because your organization has opted you into receiving pre travel notifications. For further questions about this notification please contact your organization’s travel risk management team or submit a request for information to <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.FR]: {
    subject: 'Notification de voyage - Voyage refusé',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notification de voyage - Voyage refusé',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Bonjour <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Votre voyage a été refusé.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Vous recevez cette notification car votre organisation a choisi que vous receviez des notifications avant votre voyage. Pour toute autre question concernant cette notification, veuillez contacter l\'équipe de gestion des risques liés aux voyages de votre organisation ou envoyer une demande d\'informations à <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.ES]: {
    subject: 'Notificación de viaje: viaje denegado',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificación de viaje: viaje denegado',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hola <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>tu viaje ha sido denegado.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Estás recibiendo esta notificación porque tu organización ha optado por que recibas notificaciones previas al viaje. Si tienes más preguntas sobre esta notificación, ponte en contacto con el equipo de gestión de riesgos de viaje de tu organización o envía una solicitud de información a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.DE]: {
    subject: 'Reisemeldung — Reise verweigert',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Reisemeldung — Reise verweigert',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hallo <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Deine Reise wurde verweigert.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Sie erhalten diese Benachrichtigung, weil Ihre Organisation zugestimmt hat, dass Sie Benachrichtigungen vor Reiseantritt erhalten möchten. Bei weiteren Fragen zu dieser Benachrichtigung wenden Sie sich bitte an das Reiserisikomanagement-Team Ihrer Organisation oder senden Sie eine Informationsanfrage an <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.IT]: {
    subject: 'Notifica del viaggio - Viaggio negato',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notifica del viaggio - Viaggio negato',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Ciao <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>il tuo viaggio è stato negato.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Stai ricevendo questa notifica perché la tua organizzazione ha scelto di ricevere notifiche prima del viaggio. Per ulteriori domande su questa notifica, contatta il team di gestione del rischio di viaggio della tua organizzazione o invia una richiesta di informazioni a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a></div>.',
      },
    ],
  },
  [LOCALES.JA]: {
    subject: 'トリップ通知-トリップ拒否',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'トリップ通知-トリップ拒否',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>こんにちは <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>、<div></div></div><br><div>あなたの旅行は拒否されました。</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>この通知を受け取っているのは、お客様の組織が旅行前通知の受信を選択しているためです。この通知についてさらに質問がある場合は、組織の旅行リスク管理チームに連絡するか、<a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> に情報提供のリクエストを送信してください</div>。',
      },
    ],
  },
  [LOCALES.PT]: {
    subject: 'Notificação de viagem - Viagem negada',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificação de viagem - Viagem negada',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Olá <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Sua viagem foi negada.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Você está recebendo essa notificação porque sua organização optou por receber notificações antes da viagem. Para mais perguntas sobre essa notificação, entre em contato com a equipe de gerenciamento de risco de viagem da sua organização ou envie uma solicitação de informações para <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.ZH_HANS]: {
    subject: '行程通知-行程被拒绝',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '行程通知-行程被拒绝',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>你好 <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>，<div></div></div><br><div>你的行程被拒绝了。</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>您之所以收到此通知，是因为您的组织选择了您接收旅行前通知。有关此通知的更多问题，请联系贵组织的旅行风险管理团队或向 <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> 提交信息请求。</div>',
      },
    ],
  },
  [LOCALES.ZH_HANT]: {
    subject: '行程通知-旅程被拒',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '行程通知-旅程被拒',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>您好 <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div> 您</div><br><div>的行程已被拒絕。</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>您收到此通知，因為您的組織已選擇您接收旅行前通知。如有關此通知的進一步疑問，請聯繫您組織的旅行風險管理團隊，或向 <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> 提交信息請求。</div>',
      },
    ],
  },
  [LOCALES.NL]: {
    subject: 'Reismelding - Rit geweigerd',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Reismelding - Rit geweigerd',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hallo <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>je reis is geweigerd.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Je ontvangt deze melding omdat je organisatie ervoor heeft gekozen om meldingen vóór de reis te ontvangen. Neem voor verdere vragen over deze melding contact op met het reisrisicobeheerteam van uw organisatie of stuur een verzoek om informatie naar <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.HI]: {
    subject: 'ट्रिप नोटिफिकेशन - ट्रिप अस्वीकृत',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'ट्रिप नोटिफिकेशन - ट्रिप अस्वीकृत',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>नमस्ते <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>आपकी यात्रा को अस्वीकार कर दिया गया है.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>आपको यह सूचना इसलिए मिल रही है क्योंकि आपके संगठन ने आपको यात्रा से पहले की सूचनाएं प्राप्त करने का विकल्प चुना है। इस सूचना के बारे में और प्रश्नों के लिए कृपया अपने संगठन की यात्रा जोखिम प्रबंधन टीम से संपर्क करें या <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com पर</a> जानकारी के लिए अनुरोध सबमिट</div> करें।',
      },
    ],
  },
  [LOCALES.RU]: {
    subject: 'Уведомление о поездке — поездка отклонена',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Уведомление о поездке — поездка отклонена',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Здравствуйте, <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span></div>! В<div></div> <br><div>вашей поездке отказано.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Вы получили это уведомление, потому что ваша организация разрешила вам получать предварительные уведомления о поездках. По дополнительным вопросам, связанным с этим уведомлением, обратитесь в отдел управления туристическими рисками вашей организации или отправьте запрос на получение информации по <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">адресу support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.PL]: {
    subject: 'Powiadomienie o podróży - Odmowa podróży',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Powiadomienie o podróży - Odmowa podróży',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Witaj <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Twoja podróż została odrzucona.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: 'Otrzy@@ <div>mujesz to powiadomienie, ponieważ Twoja organizacja wyraziła zgodę na otrzymywanie powiadomień przed podróżą. W przypadku dalszych pytań dotyczących tego powiadomienia prosimy o kontakt z zespołem zarządzania ryzykiem podróży w organizacji lub prześlij prośbę o informacje na <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">adres support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.HE]: {
    subject: 'הודעת נסיעה - הנסיעה נדחתה',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'הודעת נסיעה - הנסיעה נדחתה',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>שלום <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>הנסיעה שלך נדחתה.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>אתה מקבל הודעה זו מכיוון שהארגון שלך בחר לקבל התראות לפני הנסיעה. לשאלות נוספות בנוגע להודעה זו אנא פנה לצוות ניהול סיכוני הנסיעות של הארגון שלך או שלח בקשה לקבלת מידע לכתובת <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.TR]: {
    subject: 'Yolculuk Bildirimi - Yolculuk Reddedildi',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Yolculuk Bildirimi - Yolculuk Reddedildi',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Merhaba <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>, Yol<div></div></div> <br><div>culuğunuz reddedildi.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Kuruluşunuz seyahat öncesi bildirimleri almayı seçtiği için bu bildirimi alıyorsunuz. Bu bildirimle ilgili başka sorularınız için lütfen kuruluşunuzun seyahat riski yönetimi ekibiyle iletişime geçin veya <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com adresine bir bilgi talebi gönderin</a>.</div>',
      },
    ],
  },
  [LOCALES.KO]: {
    subject: '여정 알림 - 여정 거부됨',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: '여정 알림 - 여정 거부됨',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>안녕하세요 <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>여행이 거부되었습니다.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>조직에서 여행 전 알림 수신을 선택했기 때문에 이 알림을 받는 것입니다.이 알림에 대한 추가 질문은 조직의 여행 위험 관리팀에 문의하거나 <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a> 으로 정보 요청을 제출하십시오</div>.',
      },
    ],
  },
  [LOCALES.EL]: {
    subject: 'Ειδοποίηση ταξιδιού - Απόρριψη ταξιδιού',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Ειδοποίηση ταξιδιού - Απόρριψη ταξιδιού',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Γεια σας <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Το ταξίδι σας απορρίφθηκε.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Λαμβάνετε αυτήν την ειδοποίηση επειδή ο οργανισμός σας έχει επιλέξει να λαμβάνετε ειδοποιήσεις πριν από το ταξίδι. Για περισσότερες ερωτήσεις σχετικά με αυτήν την ειδοποίηση, επικοινωνήστε με την ομάδα διαχείρισης ταξιδιωτικών κινδύνων του οργανισμού σας ή υποβάλετε αίτημα για πληροφορίες στο <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.VI]: {
    subject: 'Thông báo chuyến đi - Chuyến đi bị từ chối',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Thông báo chuyến đi - Chuyến đi bị từ chối',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Xin chào <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>, Chuyến</div> <br><div>đi<div></div> của bạn đã bị từ chối.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Bạn đang nhận được thông báo này vì tổ chức của bạn đã chọn bạn nhận thông báo trước chuyến đi. Nếu có thêm câu hỏi về thông báo này, vui lòng liên hệ với nhóm quản lý rủi ro du lịch của tổ chức bạn hoặc gửi yêu cầu cung cấp thông tin đến <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.CS]: {
    subject: 'Oznámení o cestě — cesta zamítnuta',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Oznámení o cestě — cesta zamítnuta',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Dobrý den <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Vaše cesta byla zamítnuta.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Toto oznámení obdržíte, protože vaše organizace vás rozhodla přijímat oznámení před cestou. Máte-li další dotazy týkající se tohoto oznámení, obraťte se na tým pro řízení cestovních rizik vaší organizace nebo požádejte o informace na adresu <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.HU]: {
    subject: 'Utazási értesítés - Utazás elutasítása',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Utazási értesítés - Utazás elutasítása',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Helló <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>, U<div></div></div> <br><div>tazását megtagadták.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Ezt az értesítést azért kapja meg, mert szervezete választotta Önt az utazás előtti értesítések fogadására. Ha további kérdései vannak ezzel az értesítéssel kapcsolatban, kérjük, vegye fel a kapcsolatot szervezete utazási kockázatkezelő csoportjával, vagy küldjön tájékoztatási kérelmet a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com címre</a>.</div>',
      },
    ],
  },
  [LOCALES.MS]: {
    subject: 'Pemberitahuan Perjalanan - Perjalanan Ditolak',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Pemberitahuan Perjalanan - Perjalanan Ditolak',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hello <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Perjalanan anda telah ditolak.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Anda menerima pemberitahuan ini kerana organisasi anda telah memilih anda untuk menerima pemberitahuan pra-perjalanan. Untuk pertanyaan lanjut mengenai pemberitahuan ini sila hubungi pasukan pengurusan risiko perjalanan organisasi anda atau hantar permintaan maklumat kepada <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.RO]: {
    subject: 'Notificare călătorie - Călătorie refuzată',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Notificare călătorie - Călătorie refuzată',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Bună ziua <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>, C<div></div></div> <br><div>ălătoria dvs. a fost refuzată.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Primiți această notificare deoarece organizația dvs. v-a optat pentru primirea notificărilor înainte de călătorie. Pentru întrebări suplimentare cu privire la această notificare, vă rugăm să contactați echipa de gestionare a riscurilor de călătorie a organizației dvs. sau să trimiteți o solicitare de informații la <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.SK]: {
    subject: 'Oznámenie o ceste - Cesta zamietnutá',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Oznámenie o ceste - Cesta zamietnutá',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Dobrý deň <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div></div> <br><div>Vaša cesta bola zamietnutá.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Toto oznámenie dostávate preto, lebo vaša organizácia vám povolila prijímať upozornenia pred cestou. V prípade ďalších otázok týkajúcich sa tohto oznámenia kontaktujte tím riadenia cestovných rizík vašej organizácie alebo odošlite žiadosť o informácie na <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">adresu support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.TH]: {
    subject: 'แจ้งการเดินทาง - ปฏิเสธการเดินทาง',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'แจ้งการเดินทาง - ปฏิเสธการเดินทาง',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>สวัสดี <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span> การ</div> <br><div>เดินทาง<div></div> ของคุณถูกปฏิเสธ</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>คุณกำลังได้รับการแจ้งเตือนนี้เนื่องจากองค์กรของคุณได้เลือกให้คุณรับการแจ้งเตือนก่อนการเดินทางสำหรับคำถามเพิ่มเติมเกี่ยวกับการแจ้งเตือนนี้ โปรดติดต่อทีมบริหารความเสี่ยงในการเดินทางขององค์กรของคุณ หรือส่งคำขอข้อมูลไป <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">ที่ support@crisis24.com</a></div>',
      },
    ],
  },
  [LOCALES.UK]: {
    subject: 'Повідомлення про поїздку - Поїздка відхилена',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Повідомлення про поїздку - Поїздка відхилена',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Привіт <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span> <span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,<div></div> Ва</div> <br><div>ша поїздка була відхилена.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Ви отримуєте це сповіщення, оскільки ваша організація вирішила отримувати сповіщення перед поїздкою. Для отримання додаткових запитань щодо цього повідомлення, будь ласка, зв\'яжіться з командою організації з управління ризиками подорожей або надішліть запит на отримання інформації на адресу <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.BG]: {
    subject: 'Известие за пътуване - Отказано пътуване',
    components: [
      {
        order: 1,
        type: 'TITLE',
        html: 'Известие за пътуване - Отказано пътуване',
      },
      {
        order: 2,
        type: 'DIVIDER',
      },
      {
        order: 3,
        type: 'HTML',
        html: '<div>Здравейте <span class="customEmbed" data-key="First_Name" translate="no"><span contenteditable="false">&lt;First_Name&gt;</span></span> <span class="customEmbed" data-key="Last_Name" translate="no"><span contenteditable="false">&lt;Last_Name&gt;</span></span>,<div></div></div> <br><div>Вашето пътуване е отказано.</div>',
      },
      {
        order: 4,
        type: 'TRIP_DETAILS',
      },
      {
        order: 5,
        type: 'COUNTRIES',
      },
      {
        order: 6,
        type: 'DECISION_MAKER_COMMENTS',
        html: 'HTML SECITON NOT DISPLAYED',
      },
      {
        order: 7,
        type: 'DIVIDER',
      },
      {
        order: 8,
        type: 'HTML',
        html: '<div>Получавате това уведомление, защото организацията ви е избрала да получавате известия преди пътуване. За допълнителни въпроси относно това уведомление, моля свържете се с екипа за управление на риска при пътуване на вашата организация или подайте искане за информация на <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.FR_CA]: {
    subject: 'Avis de voyage - Voyage refusé',
    components: [
      {order: 1, type: 'TITLE', html: 'Avis de voyage - Voyage refusé'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Bonjour <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Votre voyage a été refusé.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Vous recevez cet avis parce que votre organisation vous a choisi de recevoir des avis préalables au voyage. Pour d\'autres questions au sujet de cet avis, veuillez communiquer avec l\'équipe de gestion des risques liés aux voyages de votre organisation ou soumettre une demande de renseignements à <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.EN_GB]: {
    subject: 'Trip Notification - Trip Denied',
    components: [
      {order: 1, type: 'TITLE', html: 'Trip Notification - Trip Denied'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hello <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Your trip has been denied.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>You are receiving this notification because your organization has opted you into receiving pre travel notifications. For further questions about this notification please contact your organization’s travel risk management team or submit a request for information to <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.AR]: {
    subject: 'إخطار الرحلة - تم رفض الرحلة',
    components: [
      {order: 1, type: 'TITLE', html: 'إخطار الرحلة - تم رفض الرحلة'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>مرحبًا <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>،</div><div><br></div><div>لقد تم رفض رحلتك.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>أنت تتلقى هذا الإشعار لأن مؤسستك قد اختارتك لتلقي إشعارات ما قبل السفر. لمزيد من الأسئلة حول هذا الإشعار، يرجى الاتصال بفريق إدارة مخاطر السفر في مؤسستك أو إرسال طلب للحصول على معلومات إلى <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.PT_BR]: {
    subject: 'Notificação de viagem - Viagem negada',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificação de viagem - Viagem negada'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Olá <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Sua viagem foi negada.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Você está recebendo esta notificação porque sua organização optou por receber notificações prévias de viagem. Para obter mais informações sobre esta notificação, entre em contato com a equipe de gerenciamento de riscos de viagem da sua organização ou envie uma solicitação de informações para <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.SV]: {
    subject: 'Anmälan om resa - Avvisad resa',
    components: [
      {order: 1, type: 'TITLE', html: 'Anmälan om resa - Avvisad resa'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hej <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Din resa har nekats.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Du får detta meddelande eftersom din organisation har valt att du ska få meddelanden före resan. För ytterligare frågor om detta meddelande, vänligen kontakta din organisations team för hantering av reserisker eller skicka en begäran om information till <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.FI]: {
    subject: 'Matkailmoitus - Matka evätty',
    components: [
      {order: 1, type: 'TITLE', html: 'Matkailmoitus - Matka evätty'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hei <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Matkasi on evätty.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Saat tämän ilmoituksen, koska organisaatiosi on valinnut sinut vastaanottamaan ennakkoilmoitukset. Jos sinulla on lisäkysymyksiä tästä ilmoituksesta, ota yhteyttä organisaatiosi matkariskien hallintaryhmään tai lähetä tietopyyntö osoitteeseen <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.DA]: {
    subject: 'Meddelelse om rejse - Rejse afvist',
    components: [
      {order: 1, type: 'TITLE', html: 'Meddelelse om rejse - Rejse afvist'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hej <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Din rejse er blevet afvist.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Du modtager denne meddelelse, fordi din organisation har valgt, at du skal modtage meddelelser før rejsen. For yderligere spørgsmål om denne meddelelse bedes du kontakte din organisations team til håndtering af rejserisici eller indsende en anmodning om oplysninger til <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.NO]: {
    subject: 'Turvarsling - Reise nektet',
    components: [
      {order: 1, type: 'TITLE', html: 'Turvarsling - Reise nektet'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hei <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Turen din er nektet.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Du mottar dette varselet fordi organisasjonen din har valgt at du mottar varsler før reisen. For ytterligere spørsmål om dette varselet, vennligst kontakt organisasjonens reiserisikostyringsteam eller send en forespørsel om informasjon til <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.CA]: {
    subject: 'Notificació de viatge - Viatge denegat',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificació de viatge - Viatge denegat'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hola <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>El teu viatge ha estat denegat.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Estàs rebent aquesta notificació perquè la teva organització t\'ha optat per rebre notificacions prèvies al viatge. Per a més dubtes sobre aquesta notificació poseu-vos en contacte amb l\'equip de gestió de riscos de viatges de la vostra organització o envieu una sol·licitud d\'informació a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
  [LOCALES.ES_MX]: {
    subject: 'Notificación de viaje - Viaje denegado',
    components: [
      {order: 1, type: 'TITLE', html: 'Notificación de viaje - Viaje denegado'},
      {order: 2, type: 'DIVIDER'},
      {
        order: 3,
        type: 'HTML',
        html: '<div>Hola <span class="customEmbed" data-key="First_Name" translate="no">﻿<span contenteditable="false">&lt;First_Name&gt;</span>﻿</span>&nbsp;<span class="customEmbed" data-key="Last_Name" translate="no">﻿<span contenteditable="false">&lt;Last_Name&gt;</span>﻿</span>,</div><div><br></div><div>Tu viaje ha sido denegado.</div>',
      },
      {order: 4, type: 'TRIP_DETAILS'},
      {order: 5, type: 'COUNTRIES'},
      {order: 6, type: 'DECISION_MAKER_COMMENTS', html: 'HTML SECITON NOT DISPLAYED'},
      {order: 7, type: 'DIVIDER'},
      {
        order: 8,
        type: 'HTML',
        html: '<div>Está recibiendo esta notificación porque su organización ha optado por recibir notificaciones previas al viaje. Si tiene más preguntas sobre esta notificación, comuníquese con el equipo de gestión de riesgos de viaje de su organización o envíe una solicitud de información a <a href="mailto:support@crisis24.com" rel="noopener noreferrer" target="_blank">support@crisis24.com</a>.</div>',
      },
    ],
  },
};
